import '../vue_widget_wrapper.js.coffee'

Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.WordcloudWidgetView extends Monitoring.Views.Charts.VueWidgetWrapper

  className: 'item word-ranking h2 w2'

  ngramsLimit: 30

  initialize: (@options = {}) ->
    super($.extend(@options, {
      widget: 'topics-wordcloud',
      menu: {
        options: [
          {
            text: 'Download PNG image',
            event: 'download-png-image'
          }
        ]
      }
    }))

    @base64Wordcloud = null
    @calculator = @options.calculator
    @calculator.on("calculate_#{@jobName}", @updateWidgetData)

    @menuEvents = {
      'download-png-image': @downloadPNGImage
    }
    @widgetEvents = {
      'export-data-changed': @updateExportData,
      'open-new-session': @openNewSession
    }

  afterAppend: =>
    job = @calculator.calculate(@jobName, @ngramsLimit)
    job.bind('failed', @displayError) if job

  updateWidgetData: (data) =>
    @vueSortableBoundWidget.update({
      isLoading: false,
      data: {
        topicRanking: data.topic_ranking,
        supplementByTopic: data.supplement_by_topic,
        metricsSpecification: @metricsSpecification()
      }
    })
    @trigger('masonry')

  metricsSpecification: ->
    []

  updateExportData: (base64) =>
    @base64Wordcloud = base64

  downloadPNGImage: =>
    link = document.createElement('a')
    link.href = @base64Wordcloud
    link.download = 'topics-cloud.png'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

  openNewSession: (topic) =>
    searchQuery = @searchQueryFor(topic)
    # analysis mode is peak peek session. Rankings drilldown works for explorer session.
    if searchQuery.get('analysisMode')
      searchQuery.set('analysisMode', false)
      searchQuery.set('exploreMode', true)

    @eventAggregator.trigger('clickOnCloneDashboard', searchQuery)

  searchQueryFor: (topic) =>
    query = @searchQuery.deepCopy()
    query.set('discovered_topics_ids', topic.topic_ids)
    query

  displayError: (response) =>
    if response?.results == 'Keepcon::Exceptions::DefaultLanguageUndefinedException'
      @_displayError(message: I18n.t('monitoring.dashboard.charts.ranking.undefined_language'), allowRetry: false)
    else
      super(response)
